/**
 * @file App.jsx
 * @description Application entry point.
 */

// import React, { useEffect } from 'react';
import AppProviders from './providers/AppProviders';
import Pages from './Pages';
import 'react-toastify/dist/ReactToastify.css';
import './styles/App.css';
import { Toaster } from 'sonner';
// import ChatWidget from './pages/AgenticAI/AI/ChatWidget';
const App = ({ instance }) => {
  return (
    <AppProviders instance={instance}>
      <Toaster position="top-right" richColors closeButton />
      {/* <ChatWidget/> */}
      <Pages />
    </AppProviders>
  );
};

export default App;
